import { Button } from "@mui/joy";
import useDetectIOS from "hooks/useDetectIOS";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import apple_logo from "static/image/common/apple_logo.svg";
import google_logo from "static/image/common/google_logo.png";
import kakao_logo from "assets/kakaoLogo.png";
import { useTranslation } from "react-i18next";
import { theme } from "styles/theme";

export default function LoginButtonTemplate({
  loginType,
  action,
  isLoggedIn,
  widthPx,
  heightPx,
}: {
  loginType: "apple" | "google" | "kakao";
  action: () => void;
  isLoggedIn: boolean;
  widthPx?: number | string;
  heightPx?: number | string;
}) {
  const user = useRecoilValue(userAtom);
  const disabled = isLoggedIn;
  const { isIOS } = useDetectIOS();

  const { t: t_ui } = useTranslation("translation", {
    keyPrefix: "ui",
  });

  const loginDataByType: {
    [key in "apple" | "google" | "kakao"]: {
      logo?: string;
      buttonText: string;
      backgroundColor: string;
      color: string;
      borderColor?: string;
    };
  } = {
    apple: {
      logo: apple_logo,
      buttonText: t_ui("로그인", { type: "Apple" }),
      backgroundColor: theme.vars.palette.Surface.Forward,
      color: theme.vars.palette.Content.Strong,
      borderColor: "none",
    },
    google: {
      logo: google_logo,
      buttonText: t_ui("로그인", { type: "Google" }),
      backgroundColor: theme.vars.palette.Surface.Forward,
      color: theme.vars.palette.Content.Strong,
      borderColor: "none",
    },
    kakao: {
      logo: kakao_logo,
      buttonText: t_ui("로그인", { type: "Kakao" }),
      backgroundColor: "#FEE500",
      color: "#3A3C40",
      borderColor: "none",
    },
  };

  const currentLoginData = loginDataByType[loginType];

  return (
    <Button
      onClick={!disabled ? action : () => {}}
      variant={"Plain"}
      color={"neutral"}
      size="lg"
      sx={{
        backgroundColor: currentLoginData.backgroundColor,
        color: currentLoginData.color,
        width: widthPx,
        height: heightPx,
        "&:focus": {
          backgroundColor: currentLoginData.backgroundColor,
          color: currentLoginData.color,
        },
      }}
      startDecorator={
        <img src={currentLoginData.logo} alt={"empty"} className="w-[20px] " />
      }
    >
      {currentLoginData.buttonText}
    </Button>
  );
}